import { render, staticRenderFns } from "./ReavaliacaoDetalhe.vue?vue&type=template&id=582719d2&"
import script from "./ReavaliacaoDetalhe.vue?vue&type=script&lang=js&"
export * from "./ReavaliacaoDetalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
